/* global axios */
import ApiClient from './ApiClient';

class ChatbotFlowsAPI extends ApiClient {
  constructor() {
    super('chatbot_flows', { accountScoped: true });
  }

  clone(flowId) {
    return axios.post(`${this.url}/${flowId}/clone`);
  }
}

export default new ChatbotFlowsAPI();
